module.exports = __webpack_public_path__ + "img/join-small.b57ea7c3.jpg";